import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import * as Yup from 'yup';
import { ERROR_MSG, } from '../../CommonUtils/contextVariables';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import moment from 'moment';

export default function UniversityWiseAffilOpeningDates() {
    const hasFetchedData = useRef(false);
    const UnivOpeningDatesValidation = Yup.object().shape({
        endDate: Yup.string().required(ERROR_MSG).nullable(),

    })
    const afflUnivWiseOpenDatesFormik = useFormik({
        initialValues: {
            startDate: "",
            endDate: "",
            remarks: "",

        },
        enableReinitialize: true,

        validationSchema: UnivOpeningDatesValidation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}insertunivdtaes`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetPreviousDatesReport();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }
    })
    const [PrevDateslog, setPrevDateslog] = useState([]);
    function GetPreviousDatesReport() {
        let url = config.url.API_URL + "getafflunivdateslog";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setPrevDateslog(res?.data?.data)

            } else {
                setPrevDateslog([]);


            }
        })
    }
    function GetAfflUnivDatesData() {
        let url = config.url.API_URL + "getafflunivdates";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const StartDate = res?.data?.data[0]?.start_date ? moment(res?.data?.data[0]?.start_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                const EndDate = res?.data?.data[0]?.end_date ? moment(res?.data?.data[0]?.end_date, 'DD/MM/YYYY').format('YYYY-MM-DD') : null;
                afflUnivWiseOpenDatesFormik?.setFieldValue("startDate", StartDate);
                afflUnivWiseOpenDatesFormik?.setFieldValue("endDate", EndDate);
            }
        })
    }
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetPreviousDatesReport();
            GetAfflUnivDatesData();
            hasFetchedData.current = true
        }
    }, [])
    return (
        <>
            <CommonFormHeading heading="Affiliation Dates" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={afflUnivWiseOpenDatesFormik}>
                    <Form onChange={afflUnivWiseOpenDatesFormik?.handleChange} onSubmit={afflUnivWiseOpenDatesFormik?.handleSubmit} className="affl-form">
                        <bie.Row className="px-2 pt-3 mb-3" >

                            <bie.Row className='px-3 my-3'>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <label className='mb-1'>Affiliation Start Date	</label>
                                    <Field type="date" name="startDate" className="form-control mb-2" disabled={true}
                                    />
                                    <ErrorMessage name="startDate" component="div" className="text-error" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                    <label className='mb-1'><b style={{ color: 'red' }}>* </b>Affiliation End Date</label>
                                    <Field type="date" name="endDate" className="form-control mb-2" min={new Date().toISOString().split('T')[0]}
                                    />
                                    <ErrorMessage name="endDate" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <label className='mb-1'>Enter Remarks			</label>
                                    <Field as="textarea" name="remarks" className="form-control mb-2" maxLength="350" />
                                    <ErrorMessage name="remarks" component="div" className="text-error" />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} style={{ marginTop: "25px" }} >
                                    <button type="submit" className="btn btn-success">
                                        Submit
                                    </button>
                                </bie.Col>
                            </bie.Row>
                            {PrevDateslog?.length > 0 && (<>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0 ">Affiliation Previous Dates</h1></div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped affl-table">
                                        <thead>
                                            <tr>
                                                <th> S.No</th>
                                                <th>Start Date </th>
                                                <th>End Date </th>
                                                <th>Remarks  </th>
                                                <th>Created Date  </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {PrevDateslog?.map((prevdata, index) => (<>
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td> {prevdata?.start_date || '-'}</td>
                                                    <td> {prevdata?.end_date || '-'}</td>
                                                    <td className='text-left'> {prevdata?.remarks || '-'}</td>
                                                    <td className='text-left'> {prevdata?.entered_on || '-'}</td>

                                                </tr>
                                            </>))}

                                        </tbody>
                                    </table>
                                </div>
                            </>)}
                        </bie.Row>
                    </Form>
                </FormikProvider>
            </bie.Container>
        </>
    )
}
